import { useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';

import { CCC_HEADER_CLASSNAME, GAME_UI_HEADER_CLASSNAME } from './constants';

export function useHeaderHeight() {
  const { gameStore } = useStores();

  const [headerHeight, setHeaderHeight] = useState(0);
  const isOldSearchMode = useFlag('enable_old_search_mode', false);

  const listener = debounce((header: HTMLDivElement) => {
    const { clientHeight } = header;

    setHeaderHeight(clientHeight);
    document.documentElement.style.setProperty('--header-height', `${clientHeight}px`);
  }, 60);

  useEffect(() => {
    const className = gameStore.showGameUi ? GAME_UI_HEADER_CLASSNAME : CCC_HEADER_CLASSNAME;
    const header = document.querySelector<HTMLDivElement>(`.${className}`);

    if (!header) {
      return;
    }

    const observer = new MutationObserver(() => {
      listener(header);
    });

    observer.observe(header, {
      childList: true,
    });

    listener(header);

    return () => {
      observer.disconnect();
    };
  }, [isOldSearchMode, listener, gameStore.showGameUi]);

  return { headerHeight };
}
